import "./style.scss"

function Loading() {
  return <div className="components_loading">
    <div>
      <i className="fa fa-circle-o-notch fa-spin fa-fw" />
      <span className="sr-only">Loading...</span>
    </div>
  </div>
}

export default Loading
